import { render, staticRenderFns } from "./GovtJobs.vue?vue&type=template&id=7a5877a0&scoped=true"
import script from "./GovtJobs.vue?vue&type=script&lang=js"
export * from "./GovtJobs.vue?vue&type=script&lang=js"
import style0 from "./GovtJobs.vue?vue&type=style&index=0&id=7a5877a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5877a0",
  null
  
)

export default component.exports